import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/sections/Hero";
import { TrustBar } from "@/components/sections/TrustBar";
import { buildSeoMeta } from "@/lib/seo";

// Lazy-load wszystko poniżej first-fold — drastycznie obniża initial JS i TBT na mobile.
const Footer = lazy(() => import("@/components/Footer").then((m) => ({ default: m.Footer })));
const About = lazy(() => import("@/components/sections/About").then((m) => ({ default: m.About })));
const Services = lazy(() => import("@/components/sections/Services").then((m) => ({ default: m.Services })));
const PlatformsMarquee = lazy(() => import("@/components/sections/PlatformsMarquee").then((m) => ({ default: m.PlatformsMarquee })));
const IntegrationMap = lazy(() => import("@/components/sections/IntegrationMap").then((m) => ({ default: m.IntegrationMap })));
const Contact = lazy(() => import("@/components/sections/Contact").then((m) => ({ default: m.Contact })));
const CaseStudies = lazy(() => import("@/components/sections/CaseStudies").then((m) => ({ default: m.CaseStudies })));
const RoiBanner = lazy(() => import("@/components/sections/RoiBanner").then((m) => ({ default: m.RoiBanner })));
const Process = lazy(() => import("@/components/sections/Process").then((m) => ({ default: m.Process })));
const FAQ = lazy(() => import("@/components/sections/FAQ").then((m) => ({ default: m.FAQ })));
const BeforeAfter = lazy(() => import("@/components/sections/BeforeAfter").then((m) => ({ default: m.BeforeAfter })));
const LeadMagnet = lazy(() => import("@/components/sections/LeadMagnet").then((m) => ({ default: m.LeadMagnet })));
const BookCall = lazy(() => import("@/components/sections/BookCall").then((m) => ({ default: m.BookCall })));
const CookieBanner = lazy(() => import("@/components/CookieBanner").then((m) => ({ default: m.CookieBanner })));

export const Route = createFileRoute("/")({
  head: () =>
    buildSeoMeta({
      title: "SyncTech | Integracje e-commerce — Baselinker, Shopify, Shoper, SellAsist",
      description:
        "Wdrożenia i integracje e-commerce: Baselinker, Shopify, Shoper, ShopGold, SellAsist, PrestaShop. Automatyzacje sprzedaży, kampanie Google Ads, Facebook Ads, GA4. Bezpłatna konsultacja.",
      path: "/",
    }),
  component: Index,
});

const SectionFallback = () => <div className="min-h-[400px]" aria-hidden />;

function Index() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Suspense fallback={<SectionFallback />}>
          <CaseStudies />
          <PlatformsMarquee />
          <About />
          <Services />
          <Process />
          <BeforeAfter />
          <RoiBanner />
          <IntegrationMap />
          <LeadMagnet />
          <BookCall />
          <FAQ />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <CookieBanner />
      </Suspense>
      <Toaster richColors position="top-right" />
    </div>
  );
}
